export const redirectOutlookUrl = `${window.location.origin}/outlook-integration`;
export const redirectGraphUrl = `${window.location.origin}/graph-integration`;
export const redirectGmailUrl = `${window.location.origin}/account-setting-gmail`;
export const redirectHubspotUrl = `${window.location.origin}/account-setting-hubspot`;
export const redirectUrlXero = window.location.origin + '/xero-sync';
export const redirectUrl = 'https://app-stage.ezymigrate.co.nz/document-sync';
export const messageConfig = { top: 50, duration: 1 };
export const forgotPasswordUrl = `${window.location.origin}/forgot-password/`;

// New UI (Next.js app) that login hands the session over to — see
// src/Common/newUiRedirect.js. Environment-specific like `redirectUrl` above.
//
// QA for every host, including localhost: a developer testing login locally
// hands off to the same New UI QA testers are on, so both see one behaviour.
// REACT_APP_NEW_UI_URL overrides it when a build needs to point elsewhere (a
// locally-run `next dev`, or a future staging/production New UI).
export const newUiUrl =
  (typeof process !== 'undefined' && process.env && process.env.REACT_APP_NEW_UI_URL) ||
  'https://qanewui.ezymigrate.co.nz';
